const pt = {
    root: { class: 'w-full' },
    table: { class: 'w-full border-collapse' },
    // Sticky thead inside DataTable's internal overflow:auto wrapper. top-0
    // (NOT top-th) is correct here — sticky positioning is relative to the
    // nearest scroll container (the wrapper div), not the viewport. The topbar
    // already sits above the table area in normal flow, so a viewport-scroll
    // can carry the entire DataTable past the topbar; the sticky thead then
    // glues itself to the top edge of its own scroll container.
    thead: { class: 'bg-gray-50 sticky top-0 z-sticky' },
    headerRow: { class: '' },
    // Note: `headerCell` and `bodyCell` PT keys are per-column inside PrimeVue 4's
    // DataTable (resolved via getColumnPT). Defining them flat at this level has
    // no effect — they have to live under `column.*`. See `column` block below.
    sortIcon: { class: 'w-3 h-3 text-gray-400' },
    tbody: { class: '[&_td]:px-3 [&_td]:py-1.5 [&_td]:text-sm [&_td]:text-gray-900' },
    bodyRow: ({ context }: { context: { selected?: boolean } }) => ({
        class: [
            'hover:bg-gray-50 cursor-pointer',
            'border-b border-gray-200',
            'transition-colors duration-fast',
            context.selected && 'bg-teal/5'
        ]
    }),
    bodyCell: { class: 'px-3 py-2.5 text-sm text-gray-900' },
    emptyMessage: { class: 'p-8 text-center text-gray-500' },
    // Header/row selection checkboxes — DataTable wraps a Checkbox under
    // `column.pcRowCheckbox`/`column.pcHeaderCheckbox` keys. The CheckIcon
    // inside uses currentColor; without `text-white` the check is black and
    // invisible against the teal-checked background. We need a thicker stroke
    // too — PrimeVue's CheckIcon is a thin svg path. Apply via stroke utilities.
    column: {
        headerCell: {
            class: [
                'px-3 py-2 text-xs font-semibold text-gray-500',
                'border-b border-gray-200 text-left whitespace-nowrap',
                // No sticky on the cell — thead handles the sticky behaviour
                // via its own pt class (sticky top-th + z-sticky).
                'bg-gray-50'
            ]
        },
        bodyCell: { class: 'px-3 py-1.5 text-sm text-gray-900' },
        pcRowCheckbox: {
            icon: { class: 'w-3.5 h-3.5 text-white' }
        },
        pcHeaderCheckbox: {
            icon: { class: 'w-3.5 h-3.5 text-white' }
        }
    },
    // Row expansion: PrimeVue renders a tr with a single full-width td for the slot
    rowExpansion: { class: 'bg-teal/5' },
    rowExpansionCell: { class: 'p-0' }
}

export default pt
